// Generic page-level loading skeleton. Used by route Suspense fallbacks so
// there is always visible feedback while a lazy chunk downloads. Mirrors the
// page template: header → KPI row → panel.

export function PageSkeleton() {
  return (
    <div aria-busy="true" aria-label="Loading page content" className="space-y-6">
      {/* Page heading skeleton */}
      <div className="space-y-2">
        <div className="pb-skeleton h-3 w-16" />
        <div className="pb-skeleton h-7 w-48" />
        <div className="pb-skeleton h-4 w-80 max-w-full" />
      </div>

      {/* KPI row skeleton */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="space-y-3 rounded-card border border-line bg-surface-1 p-5">
            <div className="pb-skeleton h-3 w-24" />
            <div className="pb-skeleton h-7 w-32" />
            <div className="pb-skeleton h-3 w-full" />
          </div>
        ))}
      </div>

      {/* Table skeleton */}
      <div className="space-y-3 rounded-card border border-line bg-surface-1 p-4">
        <div className="pb-skeleton h-3 w-32" />
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="pb-skeleton h-4 w-full" />
        ))}
      </div>
    </div>
  );
}
